import React from 'react';
import { PesquisaScorpion, FiltroStringScorpion } from 'scorpion-core'

class CriarCustomPesquisa extends React.Component {

  constructor(props) {
    super(props);
  }

  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };



  componentWillMount() {
    this.props.listar();
  }

  colunas() {
    let colunas = [
      { label: "UID", getValue: item => item.uid },
      { label: "Nome Formulário", getValue: item => item.nomeForm },
      { label: "Descrição", getValue: item => item.descricao },
    ];

    return colunas;
  }

  render() {
    const { listaPesquisa, loadingListaPesquisa, } = this.props;    

    return (<div>
      <PesquisaScorpion
        titulo={"Pesquisa de CustomForm"}
        columns={this.colunas()}
        data={listaPesquisa}
        loadingPesquisa={loadingListaPesquisa}
        getID={(item, index) => item.uid}
        {...this.props}
      >

        <FiltroStringScorpion name="filtroUID" label="UID"
          strComparaLike={item => item.uid}
          criaSugestaoPorLike={listaPesquisa} />

        <FiltroStringScorpion name="filtroNome" label="Nome Formulário"
          strComparaLike={item => item.nomeForm}
          criaSugestaoPorLike={listaPesquisa} />
        <FiltroStringScorpion name="filtroDescricao" label="Descrição"
          strComparaLike={item => item.descricao}
          criaSugestaoPorLike={listaPesquisa} />

      </PesquisaScorpion>

    </div>
    )
  }
}


export default CriarCustomPesquisa;




// WEBPACK FOOTER //
// ./src/routes/sistema/CriarCustomForm/components/CriarCustomPesquisa/CriarCustomPesquisa.js